import ReactDOM from 'react-dom';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default {
  cancel: function cancel() {},
  schedule: function schedule(fn) {
    // Enable batch updates for state changes scheduled by Relay. In React 18 this will be
    // superseded by `React.startTransition` or removed entirely if Relay enable batch updates by
    // default.
    ReactDOM.unstable_batchedUpdates(function () {
      fn();
    });
    return '';
  }
};